import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum'

/** Every host that serves real users. Add to this list, don't branch on it elsewhere. */
const PRODUCTION_HOSTNAMES = ['app.hapttic.com']

const QUERY_PARAM = 'internal'
export const isProductionHost = (): boolean => {
  try {
    return PRODUCTION_HOSTNAMES.indexOf(window.location.hostname) !== -1
  } catch (error) {
    return true
  }
}

/** The persisted, human-set opt-in. False when storage is unavailable (Safari private mode). */
export const isManuallyFlagged = (): boolean => {
  try {
    return localStorage.getItem(LocalStorageKey.INTERNAL_TESTER) === 'true'
  } catch (error) {
    return false
  }
}

export const isInternalTester = (): boolean =>
  !isProductionHost() || isManuallyFlagged()

/** Not exported: the URL is the only way to change the stored opt-in. */
const writeFlag = (internal: boolean): void => {
  try {
    if (internal) {
      localStorage.setItem(LocalStorageKey.INTERNAL_TESTER, 'true')
    } else {
      localStorage.removeItem(LocalStorageKey.INTERNAL_TESTER)
    }
  } catch (error) {}
}

const stripQueryParam = (): void => {
  try {
    const url = new URL(window.location.href)

    if (!url.searchParams.has(QUERY_PARAM)) {
      return
    }

    url.searchParams.delete(QUERY_PARAM)
    window.history.replaceState(
      window.history.state,
      '',
      `${url.pathname}${url.search}${url.hash}`
    )
  } catch (error) {
    // A URL we cannot rewrite is cosmetic; the flag has already been applied.
  }
}

/**
 * Applies `?internal=1` / `?internal=0` from the current URL, then removes the parameter.
 *
 * Call once at app start, before anything can queue an event. Any other value, and its absence,
 * leave the stored opt-in alone — it is meant to outlive the visit that set it. This runs on a
 * full page load only: appending the parameter during client-side navigation does nothing until
 * the page is reloaded.
 *
 * `?internal=0` clears the stored opt-in but cannot override rule (1): on a preview or on
 * localhost the traffic stays flagged, because it genuinely is not production traffic.
 *
 * @returns whether this session counts as internal, by either rule.
 */
export const syncInternalTesterFlag = (): boolean => {
  try {
    const requested = new URLSearchParams(window.location.search).get(
      QUERY_PARAM
    )

    if (requested === '1') {
      writeFlag(true)
    }

    if (requested === '0') {
      writeFlag(false)
    }
  } catch (error) {
    // A malformed URL must not stop the app from booting.
  }

  stripQueryParam()

  return isInternalTester()
}
